import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(
    `${process.env.REACT_APP_API_HOST}/term_responsibilities/`,
    data,
  );
};

const getAll = async () => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/term_responsibilities/`,
  );
};

const getAllByTerm = async (id) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/term_responsibilities/?filter[termino]=${id}`,
  );
};

const get = async (id) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/term_responsibilities/${id}`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(
    `${process.env.REACT_APP_API_HOST}/term_responsibilities/${id}/`,
    data,
  );
};

const remove = async (id) => {
  return await httpClient.delete(
    `${process.env.REACT_APP_API_HOST}/term_responsibilities/${id}`,
  );
};

const renumerate = async (term_id) => {
  return await httpClient.post('/term_responsibilities/renumerate/', {
    termino: term_id,
  });
};
const swap = async (a, b) => {
  return await httpClient.post('/term_responsibilities/swap/', {
    a: a,
    b: b,
  });
};

const move = async (id, data) => {
  return await httpClient.patch(`/term_responsibilities/${id}/move/`, data);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'codigo',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `${process.env.REACT_APP_API_HOST}/term_responsibilities/export` +
        `${query}&sort=${sortBy}` +
        `${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `${process.env.REACT_APP_API_HOST}/term_responsibilities` +
        `${query}&page[number]=${page}&page[size]=${pageSize}` +
        `&sort=${sortBy}` +
        `${searchBy}`,
    );
};

export {
  post,
  getAll,
  getAllByTerm,
  get,
  put,
  remove,
  ajaxTable,
  renumerate,
  swap,
  move,
};
